import { render, staticRenderFns } from "./AttachmentDetail.vue?vue&type=template&id=06975586&scoped=true&"
import script from "./AttachmentDetail.vue?vue&type=script&lang=js&"
export * from "./AttachmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06975586",
  null
  
)

export default component.exports